import styled from 'styled-components';

import {
  tangaroa,
  paradigmLightBlue,
  blueCharcoal,
} from '@paradigm/design-system/src/colors';
import PlusMinusIcon from '@paradigm/design-system/src/assets/PlusMinusIcon';

export function MarkPriceLegend() {
  return (
    <Container aria-label="unified rfq price legend">
      <LegendContainer>
        <IconContainer>
          <MarkPriceIndicator />
        </IconContainer>
        <Text>Mark or Better</Text>
      </LegendContainer>
      <LegendContainer>
        <IconContainer>
          <PlusMinusIcon />
        </IconContainer>
        <Text>Better Than Screen</Text>
      </LegendContainer>
    </Container>
  );
}
const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;
`;
const IconContainer = styled.div`
  width: 32px;
  text-align: center;
  display: flex;
  justify-content: center;
`;
const MarkPriceIndicator = styled.div`
  width: 14px;
  height: 14px;
  border: 2.5px solid ${paradigmLightBlue};
  border-radius: 3px;
`;

const Text = styled.span`
  opacity: 0.7;
`;

const Container = styled.div`
  position: absolute;
  transform: translateY(-100%);
  top: -1.3rem;
  right: 1rem;
  background-color: ${tangaroa};
  padding: 4px 12px 4px 4px;
  display: grid;
  align-items: center;
  border-radius: 3px;
  box-shadow: 0px 0px 20px 0px ${blueCharcoal};
`;
